import { createFileRoute } from "@tanstack/react-router";
import AdPerformancePage from "@/pages/admin/AdPerformance";
import { MainLayout } from "@/components/layout/MainLayout";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

const description =
  "Ad impressions, clicks, CTR, real fill rate per placement and country, plus ad-to-signup conversion, for pricing Statlign paid picks.";

export const Route = createFileRoute("/admin/ad-performance")({
  head: () => ({
    meta: [
      { title: "Ad Performance | Statlign Admin" },
      { name: "description", content: description },
      { property: "og:title", content: "Ad Performance | Statlign Admin" },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: "Ad Performance | Statlign Admin" },
      { name: "twitter:description", content: description },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <MainLayout>
      <ProtectedRoute requiredRole="admin">
        <AdPerformancePage />
      </ProtectedRoute>
    </MainLayout>
  ),
});
